import React from 'react';

export function Text() {
    const name = "text";
    Text.blockName = name;

    return (
        <block type={name}></block>
    );
}

export function TextJoin() {
    const name = "text_join";
    TextJoin.blockName = name;

    return (
        <block type={name}></block>
    );
}

export function TextAppend() {
    const name = "text_append";
    TextAppend.blockName = name;

    return (
        <block type={name}>
            <value name="TEXT">
                <shadow type="text"></shadow>
            </value>
        </block>
    );
}

export function TextLength() {
    const name = "text_length";
    TextLength.blockName = name;

    return (
        <block type={name}>
            <value name="VALUE">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}

export function TextIsEmpty() {
    const name = "text_isEmpty";
    TextIsEmpty.blockName = name;

    return (
        <block type={name}>
            <value name="VALUE">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
        </block>
    );
}

export function TextIndexOf() {
    const name = "text_indexOf";
    TextIndexOf.blockName = name;

    return (
        <block type={name}>
            <value name="VALUE">
            </value>
            <value name="FIND">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}

export function TextCharAt() {
    const name = "text_charAt";
    TextCharAt.blockName = name;

    return (
        <block type={name}>
            <value name="VALUE">
            </value>
        </block>
    );
}

export function TextGetSubstring() {
    const name = "text_getSubstring";
    TextGetSubstring.blockName = name;

    return (
        <block type={name}>
            <value name="STRING">
            </value>
        </block>
    );
}

export function TextChangeCase() {
    const name = "text_changeCase";
    TextChangeCase.blockName = name;

    return (
        <block type={name}>
            <value name="TEXT">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}

export function TextTrim() {
    const name = "text_trim";
    TextTrim.blockName = name;

    return (
        <block type={name}>
            <value name="TEXT">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}

export function TextPrint() {
    const name = "text_print";
    TextPrint.blockName = name;

    return (
        <block type={name}>
            <value name="TEXT">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}

export function TextPromptExt() {
    const name = "text_prompt_ext";
    TextPromptExt.blockName = name;

    return (
        <block type={name}>
            <value name="TEXT">
                <shadow type="text">
                    <field name="TEXT">abc</field>
                </shadow>
            </value>
        </block>
    );
}